import Cookie from 'vue-cookies'

export const hasToken = ({ token }) => {
  return !!Cookie.get('token');
}